// extracted by mini-css-extract-plugin
export default {"card":"char_card__ww4EP","inner":"char_inner__F1YOY","name":"char_name__Q465G","id":"char_id__5GeYM"};